<template>
  <div></div>
</template>

<script>
import { loadModules } from "esri-loader";
import { ref, onMounted } from "vue";

export default {
  name: "EsriDataTable",
  emits: ["dictionaries-fetched", "other-sources-fetched"], // Declare both events here

  setup(_, { emit }) {
    // Destructure the emit function from the setup context
    const internalDict = ref({});
    const linkDict = ref({});
    const otherSourcesData = ref([]);

    const queryData = () => {
      loadModules(["esri/layers/FeatureLayer"]).then(([FeatureLayer]) => {
        const layer = new FeatureLayer({
          //url: "https://geospatial.alberta.ca/arcgis/rest/services/Hosted/IrrigationCaldefaultValues/FeatureServer",
          url: "https://geospatial.alberta.ca/arcgis/rest/services/Hosted/Irrigation_Calculator_Default_Values_(View)/FeatureServer",
        });

        const query = layer.createQuery();
        query.where = "1=1";
        query.returnGeometry = false;
        query.outFields = [
          "para_internal_name",
          "para_value",
          "para_link_name",
          "para_link_url",
          "source_table",
          "para_label",
        ];

        layer
          .queryFeatures(query)
          .then((results) => {
            results.features.forEach((feature) => {
              const attributes = feature.attributes;

              let paraValue;

              // Check if the string looks like a date
              if (/^\d{4}-\d{2}-\d{2}$/.test(attributes.para_value)) {
                paraValue = attributes.para_value;
              } else {
                // If it doesn't look like a date, attempt to convert to a number
                paraValue = parseFloat(attributes.para_value);
                if (isNaN(paraValue)) {
                  paraValue = attributes.para_value;
                }
              }

              if (attributes.source_table !== "other_sources") {
                internalDict.value[attributes.para_internal_name] = paraValue;
                linkDict.value[attributes.para_link_name] =
                  attributes.para_link_url;
              } else {
                otherSourcesData.value.push({
                  linkName: attributes.para_link_name,
                  label: attributes.para_label,
                  linkUrl: attributes.para_link_url,
                });
              }
            });

            // Emit custom event with dictionaries as payload
            emit("dictionaries-fetched", {
              internalDict: internalDict.value,
              linkDict: linkDict.value,
            });

            emit("other-sources-fetched", otherSourcesData.value);
          })
          .catch((err) => {
            console.error("Failed to query data: ", err);
          });
      });
    };
    onMounted(queryData);

    // If you don't need to expose internalDict, linkDict, and otherSourcesData to the template or other parts of the component,
    // there's no need to return them from the setup function.

    // return {
    //   internalDict,
    //   linkDict,
    //   otherSourcesData,
    // };
  },
};
</script>
